import React, { useContext, useEffect, useState } from "react";
import {
  Route,
  Routes,
  redirect,
  useLocation,
  useNavigate,
} from "react-router-dom";

import AdminUserPage from "../AdminPage/User";
import AdminMenu from "../../components/Admin/Menu";
import AppContext from "../../AppContext";
import AdminLogin from "../../components/Admin/Login";
import AdminLandingPagePage from "./LandingPage";
import AdminChatPage from "./Chat";
import AdminVerificationPage from "./Verification";
import AdminSupportTicketPage from "./SupportTicket";
import AdminBlogPage from "./Blog/index.jsx";
import AdminFAQPage from "./FAQ/index.jsx";

const AdminPage = () => {
  const { isAuth, setToken, setIsAdmin } = useContext(AppContext);
  const [redirectUrl, setRedirectUrl] = useState(undefined);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setIsAdmin(true);
  }, []);

  useEffect(() => {
    if (!isAuth && location.pathname !== "/admin/login") {
      setRedirectUrl(location.pathname);
      navigate("/admin/login");
      return;
    }

    if (!isAuth) return;

    navigate("/admin/users/customers");

    // if (redirectUrl) {
    //   setRedirectUrl(undefined);
    //   navigate(redirectUrl);
    //   return;
    // }

    // if (!redirectUrl) {
    //   navigate("/admin/users/customers");
    //   return;
    // }
    // return () => {};
  }, [isAuth]);

  const handleSignIn = (token) => {
    if (redirectUrl === "/admin") setRedirectUrl("/admin/users/customers");
    setToken({accessToken: token});
  };

  return (
    <div className="admin">
      {isAuth && location.pathname !== "/admin/login" && <AdminMenu />}
      <div
        className={`admin-content ${isAuth ? "admin-content--is-auth" : ""}`}
      >
        <Routes>
          {/* <Route path="/" element={<AdminUserPage />} /> */}
          <Route path="/users/*" element={<AdminUserPage />} />
          <Route path="/landing-pages/*" element={<AdminLandingPagePage />} />
          <Route path="/chat/*" element={<AdminChatPage />} />
          <Route path="/verifications/*" element={<AdminVerificationPage />} />
          <Route path="/tickets/*" element={<AdminSupportTicketPage />} />
          <Route path="/blog/*" element={<AdminBlogPage />} />
          <Route path="/faq/*" element={<AdminFAQPage />} />
          <Route
            path="/login"
            element={<AdminLogin onSignIn={handleSignIn} />}
          />
          {/* <Route path="/trading" element={<AdminTradingPage />} />
          <Route path="/chat" element={<AdminChatPage />} />
          <Route path="/landing" element={<AdminLandingPage />} />
          <Route path="/remote" element={<AdminRemotePage />} />
          <Route path="/verify" element={<AdminVerifyPage />} />
          <Route path="/supportTicket" element={<AdminSupportTicketPage />} />
           */}
        </Routes>
      </div>
    </div>
  );
};

AdminPage.propTypes = {};

export default AdminPage;
